import { Dropdown } from "react-bootstrap";
import classes from "./../../style.module.scss";
import { ButtonDownloadPriceProfileCsv } from "./buttonDownloadPriceProfileCsv";
import { ButtonDownloadPriceProfileAsPng } from "./buttonDownloadPriceProfileAsPng";
import { ButtonDownloadSimulationCsv } from "./buttonDownloadSimulationCsv";
import { ButtonDownloadSimulationAsPng } from "./buttonDownloadSimulationAsPng";
import { ButtonDownloadNodesCsv } from "./buttonDownloadNodesCsv";
import { ButtonDownloadRevenueTablesCsv } from "./buttonDownloadRevenueTableCsv";
import { useSelector } from "react-redux";
import { ApplicationState } from "store";


interface Props {
    priceProfile: boolean,
    simulate: boolean,
    simulateTable: boolean,
    checkAypaToken: Function

}

export const ButtonDownloadMenu = ({priceProfile, simulate, simulateTable, checkAypaToken}: Props) => {
    checkAypaToken();
    const perfectForesightId = useSelector((store: ApplicationState) => store.chartReducer.perfectForesightId);
    return (
       
            <Dropdown className={classes.card__dropdown}>
                <Dropdown.Toggle id="dropdown-downloads">
                    Download
                </Dropdown.Toggle>

                <Dropdown.Menu>
                    {priceProfile && <Dropdown.Item as={ButtonDownloadPriceProfileCsv}></Dropdown.Item>}
                    {priceProfile && <Dropdown.Item as={ButtonDownloadPriceProfileAsPng}></Dropdown.Item>}
                    {priceProfile && <Dropdown.Item as={ButtonDownloadNodesCsv}></Dropdown.Item>}
                    {(simulate || simulateTable) &&<Dropdown.Item as={ButtonDownloadSimulationCsv}></Dropdown.Item>}
                    {simulate &&<Dropdown.Item as={ButtonDownloadSimulationAsPng}></Dropdown.Item>}
                    {((simulate || simulateTable) && perfectForesightId) &&<Dropdown.Item as={ButtonDownloadRevenueTablesCsv}></Dropdown.Item>}
                    
                </Dropdown.Menu>
            </Dropdown>
    )
}
